<template>
  <div class="region-container">
    <el-form-item :required="required" :label="label" >
             <el-cascader class="w-100" :disabled="disabled"
               :options="level==3?region:provinceAndCity"
			    placeholder=""
               v-model="regionModel"
               @change="addressChange">
             </el-cascader>
    </el-form-item>
	<el-form-item  v-if="level==3"  :required="requiredStreet" :label="labelStreet" >
	        <el-select :disabled="disabled"  v-if="street&&regionModel.length>=3&&level==3" class="w-100" v-model="streetModel" placeholder="" @change="streetChange">
	            <el-option 
	              v-for="item in streetList"
	              :label="item.title"
	              :value="item.title"> 
	            </el-option>
	          </el-select>
	</el-form-item>
  </div>
</template>
<script>
import { regionData,CodeToText,TextToCode ,provinceAndCityData  } from 'element-china-area-data'
  export default {
	            props: {
				  street: {
				  	type: Boolean,
				  	default:true
				  },
				  required: {
				  	type: Boolean,
				  	default:true
				  },
				  requiredStreet: {
				  	type: Boolean,
				  	default:true
				  },
				  disabled: {
				  	type: Boolean,
				  	default:false
				  },
				  level: {
				  	type: Number, 
				  	default:3
				  },
				  value:{
					  type: String,
					  default: ""
				  },
				  label:{
				  					  type: String,
				  					  default: "所在地区"
				  },
				  labelStreet:{
				  					  type: String,
				  					  default: "所在街道"
				  }
	            },
    data() {
      return {
		  regionModel:[],
		  streetModel:'',
		  region:regionData,
		    provinceAndCity:provinceAndCityData,
			streetList:[],
		regionCodes:[],
		isLoad:true
      }
    },
	watch: {
		
	    		 value(newval){
					 let array= newval?newval.split(','):[];
					 console.log(array)
					  let regionCodes=[];
					 array.forEach((item,i)=>{  
						 if(i==0){
							regionCodes.push(TextToCode[array[0]].code);
						 }
						 if(i==1){
						 							regionCodes.push(TextToCode[array[0]][array[1]].code);
						 }
						 if(i==2){
							 regionCodes.push(TextToCode[array[0]][array[1]][array[2]].code);
						 }
					 })
					 this.streetModel=array[3]||'';
					 this.regionModel=regionCodes;
					 if(array.length>=3&&this.isLoad){ 
						  this.getStreet();
					 }
					
	    		 }
	    	   },
    methods: {
		streetChange(e){
			var val=this.value.split(',').slice(0,3);
			   this.$emit('input',val+','+e);
			   this.isLoad=false;
		}, 
		addressChange(list) { 
			let str=CodeToText[list[2]]?','+CodeToText[list[2]]:'';
						 this.$emit('input',CodeToText[list[0]]+','+CodeToText[list[1]]+str);
						 this.streetModel='';
						 this.isLoad=true;
			  }, 
			  getStreet(){
				  if(this.value.split().length==0){return}
				  this.$axios.get(`/api/Region/GetRegionQueryTitle?title=${this.value.split(',')[2]}`).then(e => {
				  			 this.streetList=e; 
							 
				  });
			  }
	},
	mounted() {
	console.log(this.value)
	}
  }
</script>
<style >
	 .el-cascader-node__postfix {
	   display: none;
	}
</style>
